let application = {
    applicationName: "Application Name",
    enterApplicationName: "Please enter an application name",

    applicationKey: "Application Key",
    applicationSecret: "Application Secret",
    messageDataServerUrl: "Message data server url",
    addApplication: "Add Application",
    updateApplication: "Edit Applications",
    applicationDetail: "Application Detail",
    updateSecret: "Update Secret",
    confirmDeleteCheckedApplication: "Delete the selected applications?",
    pleaseSelectApplication:"Please select application"
}

export default application
